import styled, { css } from 'styled-components';
import { Mixins, Spacing } from 'web-common/src/shared/styles';

export const FoodTypeButtonsContainer = styled.div`
  overflow-x: auto;
  width: 100%;

  & button {
    flex: 1;
    min-width: 100px;
    max-width: 100px;
  }
`;

export const MainNeedSideContainer = styled.div``;
export const Container = styled.div`
  & ${MainNeedSideContainer} > * {
    padding: ${Spacing.SINGLE} 0;

    ${Mixins.Media.maxWidthSmall(css`
      flex-direction: column;
      align-items: flex-start;
    `)}
  }
`;
